<template>
  <div class="smsdetailApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>

    <div class="smsxq">
      <img class="fmt" src="http://admin.4008005216.com/upload/20220714/e89aba5fadacb578c28a26440e9b4fdd.png" />
      <div class="right">
        <h2>{{setSms.title}}</h2>
        <p>起步购买条数：{{setSms.bars}}条</p>
        <div class="price">
          <i><b>¥</b> {{setSms.price}}<b> /条 </b></i>
        </div>

        <div class="num">
          <font @click="jian">-</font>
          <i>{{num}}</i>
          <font class="last" @click="jia">+</font>
        </div>
      </div>
    </div>
    <div style="height:15px;"></div>
    <div class="smsDx">
      <h2>景区广告选择</h2>
      <ul>
        <li v-for="(item,i) in scenic">
          <el-checkbox @change="aa(item.id,item.advert_price)">
            <h3>{{item.title}}</h3>
            <p>本周入园次数：{{item.dayTotal}}次</p>
            <p>本月入园次数：{{item.monthTotal}}次</p>
            <p>总入园次数：{{item.total}}次</p>
            <a>￥{{item.advert_price}}</a>
          </el-checkbox>
          
        </li>
      </ul>
    </div>
    <div style="height:75px;"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>1个月使用期</span>
        <span>
          <i>￥</i><b>{{price}}</b>
        </span>
      </div>
      <div class="pay" @click="payment">
        <span>立即购买</span>        
      </div>
    </div>
  </div>
  
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        userData:[],
        num:0,
        price:0.00,
        scenic:[],
        setSms:[],
        s_id:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });

      var id = this.$route.query.id;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/smsdetail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }

    },
    mounted() {
      this.beforeMount();
      this.getscenic();
      this.getDetail();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      aa:function(id,price){
        if(!this.isInArray3(this.s_id,id)){
          this.s_id.push(id);
          this.price = this.price + (price*1)
        }else{
          this.remove(id);
          this.price = this.price - (price*1)
        }
        console.log(this.s_id)
      },
      isInArray3:function (arr,value){
        if(arr.indexOf&&typeof(arr.indexOf)=='function'){
            var index = arr.indexOf(value);
            if(index >= 0){
                return true;
            }
        }
        return false;
      },
      remove:function(val) { 
        var arr = this.s_id;
        var index = this.indexs(val);
        if(index > -1){arr.splice(index,1);}
      },
      indexs:function(val) { 
        var arr = this.s_id;
        for(var i = 0; i < arr.length; i++){
          if(arr[i] == val){return i;}
        }
        return -1; 
      },
      jia:function(){
        this.num = this.num + 500;
        this.price = (this.price - ((this.num - 500)* this.setSms.price))+(this.setSms.price * this.num);
      },
      jian:function(){
        if(this.num > 500){
          this.num = this.num - 500;
          this.price = this.price -(this.setSms.price * 500);
        }
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/message/detail',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setSms = res;
          that.price = res.price * res.bars;
          that.num = res.bars;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getscenic:function(e){
        var that = this;
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/message/scenic',
        }).then(function(response){
          var res = response.data.data;
          that.scenic = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      payment:function(){
        var that = this;
        var id = this.$route.query.p_id;
        var message_id = this.$route.query.id;
        that.axios({
          method:'post',
          url:that.$host+'home/message/payment',
          params:{
            mall_id:id,
            user_id:that.userData.id,
            price:that.price,
            total:that.num,
            message_id:message_id,
            scenic:that.s_id.toString()
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.callpay(res);
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/pushOrder";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .smsdetailApp{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }
  .smsdetailApp .smsxq{
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    border-radius:4px;
    width:92%;
    padding:15px 0;
    position:relative;
    margin:0 auto ;
  }
  .smsdetailApp .smsxq:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .smsdetailApp .smsxq .fmt{
    float:left;
    width:15%;
    border-radius:6px;
    margin:3% 2% 0 5%;
  }
  .smsdetailApp .smsxq .right{
    float:left;
    width:65%;
    margin-left:2%;
  }
  .smsdetailApp .smsxq h2{
    font-size:15px;
  }
  .smsdetailApp .smsxq p{
    font-size:13px;
    color:#666;
    padding-top:10px;
  }
  .smsdetailApp .smsxq .price{
    padding-top:10px
  }

  .smsdetailApp .smsxq .price{
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
  }
  .smsdetailApp .smsxq .price i{
    color: #FF6600;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .smsdetailApp .smsxq .price b{
    font-size:12px;
  }

  .smsdetailApp .smsxq .num{
    position:absolute;
    right:10px;
    bottom:12px
  }
  .smsdetailApp .smsxq .num i{
    font-size:14px;
    padding:0 8px;
    color:#333;
    font-style: normal;
  }
  .smsdetailApp .smsxq .num font{
    font-size:18px;
    background:#ebebeb;
    padding:1px 8px;
    text-align:center;
    border-radius:4px;
    color:#666;
  }
  .smsdetailApp .smsxq .num font.last{
    background:#2F78FF;
    color:#fff
  }

  .smsdetailApp .smsDx{
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    border-radius:4px;
    width:92%;
    position:relative;
    margin:0 auto ;
  }
  .smsdetailApp .smsDx h2{
    width:90%;
    margin:0 auto;
    font-size:16px;
    padding-top:20px;
  }
  .smsdetailApp .smsDx li label{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width:90%;
    margin:0 auto;
    border-bottom:solid 1px #f7faff;
    padding:15px 0;
    position:relative;
  }
  .smsdetailApp .smsDx li label h3{
    font-weight:550;
    font-size:14px;
    color:#000
  }
  .smsdetailApp .smsDx li label p{
    font-size:12px;
    color:#666;
    padding-top:5px;
  }
  .smsdetailApp .smsDx li label .el-checkbox__input{
    vertical-align:top;
    margin-top:3px
  }
  .smsdetailApp .smsDx li .el-checkbox__label{
    font-size:15px
  }
  .smsdetailApp .smsDx li label a{
    position:absolute;
    right:0px;
    top:60%;
    color:#f00;
    font-size:14px;
    font-weight:550
  }



  .footer1{
    height: 50px;
    background: #fff;
    width: 94%;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    position: fixed;
    bottom: 10px;
    left: 3%;
    z-index: 1
  }
  .smsdetailApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:50px;
    line-height:50px;
  }
  .smsdetailApp .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
    margin-right:15px;
  }
  .smsdetailApp .footer1 .foot-title span b{
    color: #FF6600;
    font-size:17px;
    font-weight:500;
  }

  .smsdetailApp .footer1 .foot-title span i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }

  .smsdetailApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:40%
  }
  .smsdetailApp .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #FF751A;
    border-radius:40px;
  }
</style>